import { LANG } from "constants/constants";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { registerLocale } from "react-datepicker";
import fr from "date-fns/locale/fr";
import enUS from "date-fns/locale/en-US";
import { parseValue } from "utils/helper";
import PropTypes from "prop-types";
import "./InputDateModal.scss";

// Register locales
registerLocale("fr", fr);
registerLocale("en", enUS);

export const InputDateModal = ({
  lang,
  elm,
  onChange,
  dataTestId,
  hasError = false,
}) => {
  const getDateInfo = () => {
    const fields = ["establishment_date", "start_date", "end_date"];
    const fieldName =
      fields.find((field) => elm?.[field] !== undefined) ||
      "establishment_date";
    return {
      value: elm?.[fieldName] ?? null,
      fieldName,
    };
  };

  const { value: dateValue, fieldName } = getDateInfo();

  return (
    <DatePicker
      id={`${fieldName}_${elm?.id}`}
      selected={parseValue(dateValue)}
      onChange={onChange}
      onMonthChange={onChange}
      onYearChange={onChange}
      locale={lang === LANG.EN ? "en" : "fr"}
      dateFormat={lang === LANG.EN ? "MM/dd/yyyy" : "dd/MM/yyyy"}
      placeholderText={lang === LANG.EN ? "MM/DD/YYYY" : "JJ/MM/AAAA"}
      scrollableMonthYearDropdown={true}
      yearDropdownItemNumber={12}
      dropdownMode="select"
      showMonthDropdown={true}
      showYearDropdown={true}
      className={`sourcesanspro-normal-gray-suit-18pxmt-10 ${
        hasError ? "input-date-error" : ""
      }`}
      popperProps={{
        strategy: "fixed",
        modifiers: [
          { name: "preventOverflow", options: { boundary: "viewport" } },
        ],
      }}
      popperPlacement="bottom-start"
      dataTestId={dataTestId}
    />
  );
};

InputDateModal.propTypes = {
  lang: PropTypes.string,
  elm: PropTypes.object,
  onChange: PropTypes.func,
  dataTestId: PropTypes.string,
  hasError: PropTypes.bool,
};
